import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import RecipeCard from "./RecipeCard";
import { HomeImg, ImgDiv } from "./HomeStyles";
import homeSvg from "../../assets/home.svg";

// API keys are used in backend proxy server

const Home = () => {
    const [query, setQuery] = useState("");
    const [mealType, setMealType] = useState("Breakfast");
    const [recipes, setRecipes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getData = async (searchQuery = query) => {
        if (!searchQuery.trim()) {
            console.log("Query is empty");
            return;
        }

        setLoading(true);
        setError(null);

        try {
            // Edamam API call through proxy server
            const url = `http://localhost:5000/api/recipes?q=${encodeURIComponent(
                searchQuery
            )}&mealType=${mealType}`;

            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setRecipes(data.hits);
            console.log("API Response:", data.hits);
        } catch (error) {
            console.error("Error fetching data:", error);
            setError(
                "An error occurred while loading recipes. Please try again."
            );
            setRecipes([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Initial load with default query
        const defaultQuery = "chicken";
        setQuery(defaultQuery);
        getData(defaultQuery);
        // eslint-disable-next-line
    }, []);

    // Debounced search effect
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (query && query.length >= 2) {
                getData(query);
            }
        }, 500); // 500ms delay

        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    // Effect for meal type changes
    useEffect(() => {
        if (query && query.length >= 2) {
            getData(query);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mealType]);

    console.log(recipes);

    return (
        <div>
            <Header
                setQuery={setQuery}
                setMealType={setMealType}
                getData={() => getData(query)}
            />

            {loading && (
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <p>Loading recipes...</p>
                </div>
            )}

            {error && (
                <div
                    style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "red",
                    }}
                >
                    <p>{error}</p>
                </div>
            )}

            {!loading && !error && recipes.length > 0 ? (
                <div>
                    <RecipeCard recipes={recipes} />
                </div>
            ) : !loading && !error ? (
                <ImgDiv>
                    <HomeImg src={homeSvg} />
                </ImgDiv>
            ) : null}
        </div>
    );
};

export default Home;
